/* Publish by EComposer at 2026-10-02 15:13:06*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vmixf69id9"]=  window.__ectimmers["ecom-vmixf69id9"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-vmixf69id9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vmixf69id9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-buagokf5ypn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-buagokf5ypn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8l35ph1h42').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8l35ph1h42', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j0ug67bwor').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j0ug67bwor', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jpcoj1ukh8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jpcoj1ukh8', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-au9tfjxklcp"]=  window.__ectimmers["ecom-au9tfjxklcp"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-au9tfjxklcp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-au9tfjxklcp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p7vwnlbeani').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p7vwnlbeani', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}